import moment from "moment"
import React from "react"
import ReactTooltip from "react-tooltip"
import Icon from "../Icon/Icon"

interface Props {
	tooltipId: string
	createdAt?: string | Date
}

function buildTooltipContent(createdAt?: string | Date): string {
	const formatted = createdAt && moment(createdAt).isValid() ? moment(createdAt).format("L") : undefined
	if (formatted) {
		return `This check has an active stop payment (placed on ${formatted}). If deposited, it will be automatically returned.`
	}
	return "This check has an active stop payment. If deposited, it will be automatically returned."
}

export function StopPaymentIcon({tooltipId, createdAt}: Props) {
	return (
		<span data-tip="React-tooltip" data-for={tooltipId} style={{display: "inline-flex", alignItems: "center"}}>
			<Icon icon="stop-payment" size={16} style={{color: "#FF506F"}} />
			<ReactTooltip className="tooltip-info" id={tooltipId} effect="solid">
				{buildTooltipContent(createdAt)}
			</ReactTooltip>
		</span>
	)
}
